
export default function VirtualTourSection() {
  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Image Side */}
            <div className="relative h-64 lg:h-auto">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20training%20facility%20interior%20with%20classrooms%20computer%20labs%20and%20professional%20learning%20spaces%20featuring%20contemporary%20furniture%20natural%20lighting%20and%20state-of-the-art%20equipment%20for%20skills%20development&width=600&height=400&seq=virtual-tour&orientation=landscape"
                alt="Sylman Academy Training Facilities"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">Virtual Tour Available</span>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12">
              <div className="mb-6">
                <div className="w-16 h-16 bg-[#2D7F3E] text-white rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-camera-3-line text-2xl"></i>
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Virtual Facility Tour
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed mb-6">
                  Experience our state-of-the-art training facilities from anywhere. This exclusive virtual tour showcases our modern classrooms, computer labs, and specialised training areas.
                </p>
              </div>

              <div className="bg-[#f0f9f2] border border-[#c8e6cf] rounded-lg p-4 mb-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#2D7F3E] text-white rounded-full flex items-center justify-center mr-3 mt-0.5">
                    <i className="ri-information-line text-sm"></i>
                  </div>
                  <div>
                    <p className="text-[#1A3A22] font-medium mb-1">Exclusive Access</p>
                    <p className="text-[#256632] text-sm">
                      This exclusive tour is available after our initial conversation to ensure personalized guidance
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <h3 className="font-semibold text-gray-900">What You'll See:</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Modern Classrooms</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Computer Labs</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Training Equipment</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Study Areas</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Assessment Centres</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-[#2D7F3E] mr-2"></i>
                    <span className="text-gray-700 text-sm">Student Facilities</span>
                  </div>
                </div>
              </div>

              <button className="w-full btn btn-primary btn-lg">
                Schedule Consultation to Access Tour
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
